// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateGuestPositionReducer extends Reducer
{
	public static reducerName: string = "UpdateGuestPosition";
	public static call(_positionX: number, _positionY: number) {
		this.getReducer().call(_positionX, _positionY);
	}

	public call(_positionX: number, _positionY: number) {
		const serializer = this.client.getSerializer();
		let _positionXType = AlgebraicType.createPrimitiveType(BuiltinType.Type.I32);
		serializer.write(_positionXType, _positionX);
		let _positionYType = AlgebraicType.createPrimitiveType(BuiltinType.Type.I32);
		serializer.write(_positionYType, _positionY);
		this.client.call("UpdateGuestPosition", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let positionXType = AlgebraicType.createPrimitiveType(BuiltinType.Type.I32);
		let positionXValue = AlgebraicValue.deserialize(positionXType, adapter.next())
		let positionX = positionXValue.asNumber();
		let positionYType = AlgebraicType.createPrimitiveType(BuiltinType.Type.I32);
		let positionYValue = AlgebraicValue.deserialize(positionYType, adapter.next())
		let positionY = positionYValue.asNumber();
		return [positionX, positionY];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _positionX: number, _positionY: number) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _positionX: number, _positionY: number) => void)
	{
		this.client.on("reducer:UpdateGuestPosition", callback);
	}
}


export default UpdateGuestPositionReducer
